"use client";

import { useCartStore } from "~/stores/useCartStore";

/** Whether the cart currently contains any product matching one of the given slugs. */
export const useHasProductInCart = (slugs: readonly string[]) => {
    const cartItems = useCartStore((s) => s.cartItems);

    return cartItems.some((item) => item.slug && slugs.includes(item.slug));
};

export default useHasProductInCart;
